import dynamic from 'next/dynamic'

export const SectionOfThumbnails = dynamic(
    () => import('./section-of-thumbnails')
)
